/* import __COLOCATED_TEMPLATE__ from './entry-table-individual.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import dayjs from 'dayjs';

export default class EntriesTableIndividualRowComponent extends Component 
{
	@service store;
	
	@tracked entry;
	@tracked enteredBib = "";

	@action
	async bibEntered(browserEvent)
	{
		const bib = this.enteredBib;
		const event = this.args.event;
		
		this.entry = null;
		
		const entries = await event.get('entries');
		for(const entry of entries)
		{
			if(entry.bib == bib)
			{
				const entryRef = this.store.getReference('entry', entry.id);
				await entryRef.reload();
				
				entry.set('showDetails',true);
				this.entry = entry;
			}
		}
	}
}